// This file is automatically generated. Do not edit manually.

import { PartConfigurationTemplateView } from "src/api/generated/erp/db/types/tables/partConfigurationTemplateView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace PartConfigurationTemplatesApi {
	export async function getSalesPartConfigurationTemplates(args: {
		salesPartId: number;
	}): Promise<Array<PartConfigurationTemplateView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/managing/configurationTemplates/getSalesPartConfigurationTemplates",
			method: "POST",
			data: {
				salesPartId: args.salesPartId,
			},
		});
		return response as Array<PartConfigurationTemplateView>;
	}
}
